import { Pressable, Text, View } from 'react-native'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'
import { useTranslation } from 'react-i18next'

import { cn } from '@/utils/cn'
import { Close, Upload } from '@/components/icon'

import { BottomSheet } from './BottomSheet'

export function SelectVideoSheet(props: SheetProps<'select-video'>) {
  const { t } = useTranslation()
  async function handleOpenImageViewer() {
    await SheetManager.hide(props.sheetId)
    setTimeout(() => {
      props.payload?.openImageViewer()
    }, 300)
  }

  return (
    <BottomSheet>
      <Pressable onPress={handleOpenImageViewer}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Upload className={'size-6 text-text-tertiary'} />
            <Text className={'text-base text-text-primary'}>{t('ui:chooseAnotherVideo')}</Text>
          </View>
        )}
      </Pressable>
      <Pressable onPress={() => SheetManager.hide(props.sheetId)}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Close className={'size-6 text-text-tertiary'} />
            <Text className={'text-base text-text-primary'}>{t('ui:cancel')}</Text>
          </View>
        )}
      </Pressable>
    </BottomSheet>
  )
}
